<template>
  <CollapsibleRoot v-model:open="model">
    <CollapsibleTrigger
      type="button"
      class="mt-px flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-sm font-medium text-gray-700 outline-2 outline-blue-500 transition hover:bg-gray-300/50 focus-visible:outline active:bg-gray-300/50 dark:text-white dark:hover:bg-muted dark:active:bg-card"
    >
      <ChevronDownIcon
        class="size-4 text-gray-500 transition-transform dark:text-muted-foreground"
        :class="[!model && `-rotate-90`]"
      />
      {{ title }}
    </CollapsibleTrigger>

    <CollapsibleContent :class="$style.content">
      <div class="ml-4 flex flex-col pl-2">
        <slot></slot>
      </div>
    </CollapsibleContent>
  </CollapsibleRoot>
</template>

<script setup lang="ts">
import {
  CollapsibleContent,
  CollapsibleRoot,
  CollapsibleTrigger,
} from "reka-ui";

import ChevronDownIcon from "@/icons/heroicons/chevron-down-micro.svg";

defineProps<{
  title: string;
}>();

const model = defineModel<boolean>({ default: false });
</script>

<style module>
.content {
  overflow: hidden;

  @media (prefers-reduced-motion: no-preference) {
    &[data-state="open"] {
      animation: slide-open 150ms cubic-bezier(0.4, 0, 0.2, 1);
    }

    &[data-state="closed"] {
      animation: slide-close 150ms cubic-bezier(0.4, 0, 0.2, 1);
    }
  }
}

@keyframes slide-open {
  from {
    opacity: 0;
    height: 0;
  }
  to {
    opacity: 1;
    height: var(--reka-collapsible-content-height);
  }
}

@keyframes slide-close {
  from {
    opacity: 1;
    height: var(--reka-collapsible-content-height);
  }
  to {
    opacity: 0;
    height: 0;
  }
}
</style>
